import { createContext, useContext } from "react";

type UnsavedEditsSyncContextType = {
  flushUnsavedEdits: () => Promise<boolean>;
  pauseSync: () => void;
  resumeSync: () => void;
  // Mutable version counter. Increment to tell all trackers to re-baseline on the next form change.
  trackerResetVersionRef: React.RefObject<number>;
  registerRequiredKeys: (subtemplateIndex: number, keys: Set<string>) => void;
  unregisterRequiredKeys: (subtemplateIndex: number) => void;
  registerTrackedKeys: (subtemplateIndex: number, keys: Set<string>) => void;
  unregisterTrackedKeys: (subtemplateIndex: number) => void;
  getTrackedKeys: (subtemplateIndex: number) => Set<string> | undefined;
};

const defaultVersionRef = { current: 0 };

export const UnsavedEditsSyncContext = createContext<UnsavedEditsSyncContextType>({
  flushUnsavedEdits: () => Promise.resolve(true),
  pauseSync: () => undefined,
  resumeSync: () => undefined,
  trackerResetVersionRef: defaultVersionRef,
  registerRequiredKeys: () => undefined,
  unregisterRequiredKeys: () => undefined,
  registerTrackedKeys: () => undefined,
  unregisterTrackedKeys: () => undefined,
  getTrackedKeys: () => undefined
});

export const useUnsavedEditsSyncContext = () => useContext(UnsavedEditsSyncContext);
